import React, { FC } from 'react';
import { ShimmerThumbnail } from 'react-shimmer-effects';
import Props from './typing';
import './style.scss';

const TableSkeleton: FC<Props> = ({
  rows = 6,
  columns = 5,
  showHeader = true,
  showPagination = false,
  minColumnWidth = 120,
  className = '',
}): JSX.Element => {
  const columnItems = Array.from({ length: columns });
  const rowItems = Array.from({ length: rows });
  const rowStyle = {
    gridTemplateColumns: `repeat(${columns}, minmax(${minColumnWidth}px, 1fr))`,
  };

  return (
    <div
      className={`table-skeleton ${className}`}
      role='status'
      aria-live='polite'
    >
      {showHeader && (
        <div
          className='table-skeleton__row table-skeleton__row--header'
          style={rowStyle}
        >
          {columnItems.map((_, index) => (
            <div className='table-skeleton__cell' key={`header-${index}`}>
              <ShimmerThumbnail
                className='table-skeleton__shimmer'
                height={16}
                rounded
              />
            </div>
          ))}
        </div>
      )}
      {rowItems.map((_, rowIndex) => (
        <div
          className='table-skeleton__row'
          key={`row-${rowIndex}`}
          style={rowStyle}
        >
          {columnItems.map((_, columnIndex) => (
            <div
              className='table-skeleton__cell'
              key={`row-${rowIndex}-column-${columnIndex}`}
            >
              <ShimmerThumbnail
                className='table-skeleton__shimmer'
                height={columnIndex === 0 ? 18 : 14}
                rounded
              />
            </div>
          ))}
        </div>
      ))}
      {showPagination && (
        <div className='table-skeleton__pagination'>
          <ShimmerThumbnail
            className='table-skeleton__pagination-item table-skeleton__pagination-item--wide'
            height={24}
            rounded
          />
          <div className='table-skeleton__pagination-pages'>
            {Array.from({ length: 5 }).map((_, index) => (
              <ShimmerThumbnail
                className='table-skeleton__pagination-item'
                height={24}
                key={`pagination-${index}`}
                rounded
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TableSkeleton;
